import { useEffect } from "react";
import { useStockControlStore } from "../hooks/useStockControlStore";
import { useDepositosStore } from "../hooks/useDepositosStore";
import { useLoading } from "../hooks/useLoading";
import inventario from "../api/inventario";
import { useNavigate } from "react-router";

let articulosPendientesGlobal = [];

export const useControlStockAlAzar = () => {
  const {
    setArticuloActual,
    setStockReal,
    agregarArticuloControlado,
    articuloActual,
    stockReal,
    setMsgError,
    setMensajeComprobante,
    resetFormulario,
    resetArticulosControlados,
    articulosControlados,
  } = useStockControlStore();

  const { depositoSeleccionado } = useDepositosStore();
  const { loading, withLoading } = useLoading();
  const idEmpleado = JSON.parse(localStorage.getItem("idEmpleado")) || null;
  const navigate = useNavigate();

  useEffect(() => {
    if (depositoSeleccionado) {
      reiniciarYInicializar();
    }
  }, [depositoSeleccionado]);

  const reiniciarYInicializar = async () => {
    resetFormulario();
    setArticuloActual(null);
    setMensajeComprobante("");
    setStockReal(null);
    articulosPendientesGlobal = [];
    resetArticulosControlados();
    await inicializar();
  };

  const inicializar = async () => {
    if (!depositoSeleccionado) {
      setMsgError("No hay un depósito seleccionado.");
      return;
    }

    try {
      const lista = await withLoading(async () => {
        return await inventario.getListaArticulosIMA(depositoSeleccionado.idDeposito);
      });

      if (!Array.isArray(lista)) throw new Error("Respuesta inesperada de la API");
      articulosPendientesGlobal = lista.map(a => a.idArticulo);
      await avanzarArticulo();
    } catch (error) {
      console.error(" Error al inicializar artículos al azar", error);
      setMsgError("No se pudo obtener la lista de artículos del depósito.");
    }
  };

  const avanzarArticulo = async () => {
    if (!depositoSeleccionado) {
      setMsgError("Depósito no definido.");
      return;
    }

    if (articulosPendientesGlobal.length === 0) {
      await finalizarControl();
      return;
    }

    const indice = Math.floor(Math.random() * articulosPendientesGlobal.length);
    const idArticulo = articulosPendientesGlobal.splice(indice, 1)[0];

    try {
      await withLoading(async () => {
        const detalle = await inventario.getArticuloIMAPorId(idArticulo);
        const fecha = new Date().toISOString().split("T")[0];
        const stockTeorico = await inventario.getStockTeoricoIMA(idArticulo, depositoSeleccionado.idDeposito, fecha);

        const articulo = {
          idArticulo: detalle.idArticulo,
          descripcion: detalle.descripcion,
          codigo: detalle.codigo,
          codigoBarra: detalle.codigoBarra,
          ubicacion: detalle.ubicacion,
          stockTeorico,
          stockReal: 0,
        };

        setArticuloActual(articulo);
        setStockReal(null);
      });
    } catch (error) {
      console.error("Error al obtener artículo al azar", error);
      setMsgError("No se pudo obtener el artículo.");
    }
  };

  const guardarYAvanzar = async () => {
    if (!articuloActual || stockReal === null || isNaN(stockReal)) {
      setMsgError("Falta el stock real.");
      return;
    }

    agregarArticuloControlado({ ...articuloActual, stockReal });
    resetFormulario();
    await avanzarArticulo();
  };

  const finalizarControl = async () => {
    if (!idEmpleado || !depositoSeleccionado?.idDeposito) {
      setMsgError("Faltan datos de usuario o del depósito.");
      return;
    }

    if (articulosControlados.length === 0) {
      setMensajeComprobante("No se controló ningún artículo durante el ciclo de inventario.\n\nControl finalizado sin movimientos registrados.");
      setTimeout(() => {
        navigate(-1);
      }, 3000);
      return;
    }

    try {
      const movimientos = articulosControlados.map(a => ({
        idArticulo: a.idArticulo,
        cantidad: a.stockReal,
        stockReal: a.stockReal,
        stockTeorico: a.stockTeorico,
      }));

      const comprobante = await withLoading(async () => {
        return await inventario.persistirAjustes(idEmpleado, depositoSeleccionado.idDeposito, movimientos);
      });

      if (comprobante) {
        setMensajeComprobante(`Se guardaron los ajustes por inventario correspondientes.\n\nComprobante Nº\n${comprobante}`);

        setTimeout(() => {
          navigate(-1);
        }, 3000);
      }
    } catch (error) {
      console.error(" Error al guardar ajuste final", error);
      setMsgError("No se pudo guardar el ajuste final.");
    }
  };

  const marcarComoInexistente = async () => {
    setStockReal(0);
    await guardarYAvanzar();
  };

  const noControlar = async () => {
    if (articulosPendientesGlobal.length === 0) {
      await finalizarControl();
    } else {
      resetFormulario();
      await avanzarArticulo();
    }
  };

  return {
    inicializar,
    guardarYAvanzar,
    marcarComoInexistente,
    noControlar,
    loading,
  };
};
